"use strict";

import * as React from 'react';
/**
 * Context for the parent route of a navigator.
 */
export const NavigationFocusedRouteStateContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=NavigationFocusedRouteStateContext.js.map